import { Accordion } from '../../../../../components/general/accordion';
import EmailIcon from '@mui/icons-material/Email';
import { Table } from '../../../../../components/general/table';
import { usePqrMailHistory } from './hook';
import { PqrMailHistoryProps } from './props';

export const PqrMailHistory = (props: PqrMailHistoryProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        usePqrMailHistory(props);

    return (
        <Accordion
            title="HISTÓRICO EMAIL"
            icon={<EmailIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Table
                columns={columns}
                rows={rows}
                rowCount={total}
                loading={loading}
                paginationModel={{
                    page,
                    pageSize,
                }}
                onPaginationModelChange={paginator}
                pageSizeOptions={[2, 10, 20, 50]}
                disableRowSelectionOnClick
            />
        </Accordion>
    );
};
